import { Token } from "@siteimprove/alfa-css";
import { Option } from "@siteimprove/alfa-option";
import { Parser } from "@siteimprove/alfa-parser";
import { Specificity } from "../../specificity.js";
import { WithName } from "../selector.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/selectors/#id-selector}
 *
 * @public
 */
export class Id extends WithName {
    static of(name) {
        return new Id(name);
    }
    _key;
    constructor(name) {
        super("id", name, Specificity.of(1, 0, 0));
        this._key = Option.of(this);
    }
    matches(element) {
        return element.id.includes(this._name);
    }
    equals(value) {
        return value instanceof Id && value._name === this._name;
    }
    *[Symbol.iterator]() {
        yield this;
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
    toString() {
        return `#${this._name}`;
    }
}
/**
 * @public
 */
(function (Id) {
    function isId(value) {
        return value instanceof Id;
    }
    Id.isId = isId;
    /**
     * {@link https://drafts.csswg.org/selectors/#typedef-id-selector}
     *
     * @internal
     */
    Id.parse = map(Token.parseHash((hash) => hash.isIdentifier), (hash) => Id.of(hash.value));
})(Id || (Id = {}));
//# sourceMappingURL=id.js.map